import React, {useState} from 'react';
import axios from 'axios';
import {FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import {PINField} from '../utils/validation/auth/AuthValidators';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import styles from '../styles/login/LoginForm.module.css';
import ErrorMessage from '../elements/ErrorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons/faChevronRight';

const VerifyTokenForm = (props) => {
    const {token, email, setToken, changeStep} = props;
    const [isLoading, editIsLoading] = useState(false);
    const [hasError, editHasError] = useState(false);

    //load validation rules for fields
    const ValidationRules = {
        token: PINField
    };

    //blur validation
    function validateFieldOnBlur(e){
        const value = e.target.value;
        const id= e.target.id;
        const res = ValidationRules[id](value);
        ShowValidation(id, res);
    }

    const resendVerificationEmail = async () => {
       
        try{
            editHasError(false);
            const response = await axios({
                method: "post",
                url: process.env.NEXT_PUBLIC_API + "/api/forgot-password",
                data: {email: email},
                headers: {'Content-Type': 'application/json'}
            });
            editIsLoading(false);
            if (response.data.status==true) {
                setToken('');
            } else {
               editHasError(response.data.error);
            }
            
        } catch(err) {
            editIsLoading(false);
            editHasError("Ups, avem o problemă. Te rugăm să încerci mai târziu.");
        }
    }

    const handleTokenVerification = async (e) => {
        e.preventDefault();
        let validForm = FormValidator('verifyTokenForm', ValidationRules); 
        if (validForm) {
            editIsLoading(true);
            try{
                editHasError(false);
                const response = await axios({
                    method: "post",
                    url: process.env.NEXT_PUBLIC_API + "/api/token-password",
                    data: {email: email, verification_code: token},
                    headers: {'Content-Type': 'application/json'}
                });
                editIsLoading(false);
                if (response.data.status==true) {
                    changeStep('password');
                } else {
                    if (response.data.error == 'Codul de verificare a expirat.') {
                        let errorMsg = <>
                                            {response.data.error }
                                            <Button variant="link" className="ps-0" onClick={resendVerificationEmail}>
                                            <FontAwesomeIcon icon={faChevronRight} height="16" width="16" />
                                            Retrimite codul pe email</Button>
                                        </>;
                        editHasError(errorMsg);
                    } else {
                        editHasError(response.data.error);
                    }
                }
                
            } catch(err) {
                editIsLoading(false);
                editHasError("Ups, avem o problemă. Te rugăm să încerci mai târziu.");
            }
        }


    }

    const spinner = isLoading &&  <><Spinner as="span" animation="grow" size="sm" role="status"
                                    aria-hidden="true" />
                                    Te rugăm să aștepți...
                                    </>;
    const btnDisabled = isLoading && 'disabled';
    const confirmTokenBtn =  <Button variant="secondary" type="submit" className="col-12" disabled={btnDisabled}  >
                                {spinner}
                                {!isLoading && 'Continuă'}
                            </Button>;

    const errorMessage = hasError && <div className="mb-3">
                        <ErrorMessage title="Eroare" message={hasError} />
                        </div>; 


    return(
        <>
            {hasError ? errorMessage :
                <p className={styles.wizzardTitle}>
                    Am trimis un cod de verificare la adresa {email}, dacă aceasta există în sistem.
                </p>
            }
            <Form id="verifyTokenForm" onSubmit={handleTokenVerification}>
                <Form.Group controlId="token">
                    <Form.Label className={styles.login}>Codul primit pe email</Form.Label>
                    <Form.Control type="number" name="token" placeholder="Codul de verificare" 
                        onChange={setToken} 
                        onBlur={validateFieldOnBlur}
                        value={token}         
                    />
                    <Form.Text className="helper" as="div">    
                    </Form.Text>
                </Form.Group>  
                {confirmTokenBtn}
            </Form>
            
        </>
    );

}

export default VerifyTokenForm;